"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var _ = require("lodash");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("../../utils");
var AccountsList = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsList, _super);
    function AccountsList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.toggleModal = function () {
            var nextState = {
                isOpen: !_this.state.isOpen,
                userSelectedAccounts: [],
                showAccountsNames: _this.state.showAccountsNames
            };
            if (nextState.isOpen) {
                nextState.userSelectedAccounts = _this.props.selectedAccounts;
            }
            _this.setState(nextState);
        };
        _this.setAccounts = function () {
            var setSelectedAccounts = _this.props.setSelectedAccounts;
            var userSelectedAccounts = _this.state.userSelectedAccounts;
            if (userSelectedAccounts.length) {
                setSelectedAccounts(userSelectedAccounts, true);
            }
            _this.toggleModal();
        };
        _this.onSelectAccountDirect = function (account) {
            var setSelectedAccounts = _this.props.setSelectedAccounts;
            setSelectedAccounts([account._id], true);
            _this.toggleModal();
        };
        _this.onSelectAccount = function (accounts) {
            var isMultiSelectAllow = _this.props.isMultiSelectAllow;
            var userSelectedAccounts = accounts;
            if (!isMultiSelectAllow) {
                userSelectedAccounts = [accounts];
            }
            _this.setState({ userSelectedAccounts: userSelectedAccounts });
        };
        _this.onChangeShowAccountsNames = function (e) {
            var value = utils_1.normalizeEventValue(e);
            _this.setState({ showAccountsNames: value });
            localStorage.setItem("showAccountsNames", JSON.stringify(value));
        };
        var showAccountsNames = localStorage.getItem("showAccountsNames");
        if (!showAccountsNames) {
            showAccountsNames = JSON.stringify(true);
            localStorage.setItem("showAccountsNames", showAccountsNames);
        }
        _this.state = { isOpen: false, userSelectedAccounts: [], showAccountsNames: JSON.parse(showAccountsNames) };
        return _this;
    }
    AccountsList.prototype.componentDidMount = function () {
        if (!this.state.userSelectedAccounts.length) {
            this.setState({ userSelectedAccounts: this.props.selectedAccounts });
        }
    };
    AccountsList.prototype.renderNetworkAccounts = function () {
        var _this = this;
        var _a = this.props, accounts = _a.accounts, selectedAccounts = _a.selectedAccounts, isMultiSelectAllow = _a.isMultiSelectAllow, maxItems = _a.maxItems;
        var selectedAccount = this.state.userSelectedAccounts[0] || selectedAccounts[0];
        var groups = {};
        if (isMultiSelectAllow) {
            selectedAccount = this.state.userSelectedAccounts;
            accounts.forEach(function (account) {
                var network = account.network;
                if (groups[network._id]) {
                    groups[network._id].accounts.push(account);
                }
                else {
                    groups[network._id] = {
                        network: network,
                        accounts: [account]
                    };
                }
            });
        }
        var props = {
            onSelectionChange: this.onSelectAccount,
            value: selectedAccount,
            label: isMultiSelectAllow ? "Select accounts" : "Select account",
            surfaceLevel: 0,
            maxItems: maxItems || 10,
            searchable: true,
            allowOnlySameGroupSelection: true,
            multiple: isMultiSelectAllow,
            required: true,
            focus: true
        };
        var render;
        if (isMultiSelectAllow) {
            render = (React.createElement("div", null,
                React.createElement(ui_1.FormMultiSelect, tslib_1.__assign({}, props), _.map(groups, function (group) {
                    return (React.createElement(ui_1.MultiSelectGroup, { label: group.network.name, value: group.network._id, key: group.network._id }, _.map(group.accounts, function (account) {
                        return (React.createElement(ui_1.MultiSelectOption, { label: account.username, value: account._id, key: account._id },
                            React.createElement("div", { onClick: _this.onSelectAccountDirect.bind(_this, account), className: theme.selectBtn }, "select only")));
                    })));
                }))));
        }
        else {
            render = (React.createElement("div", null,
                React.createElement(ui_1.FormMultiSelect, tslib_1.__assign({}, props), _.map(accounts, function (account) {
                    return (React.createElement(ui_1.MultiSelectOption, { label: account.username, value: account._id, key: account._id },
                        React.createElement("div", { onClick: _this.onSelectAccountDirect.bind(_this, account), className: theme.selectBtn }, "select only")));
                }))));
        }
        return render;
    };
    AccountsList.prototype.render = function () {
        var _a = this.props, selectedAccounts = _a.selectedAccounts, indexAccounts = _a.indexAccounts, mouseOnAppBar = _a.mouseOnAppBar, isMultiSelectAllow = _a.isMultiSelectAllow;
        var showAccountsNames = this.state.showAccountsNames;
        var selectedAccountsNames = selectedAccounts.map(function (id) { return indexAccounts[id].username; });
        var props = {
            badgeLabelBottom: selectedAccountsNames.join(" | ")
        };
        if (!showAccountsNames) {
            props = {
                badgeLabel: selectedAccounts.length
            };
        }
        return (React.createElement(ui_1.MainMenu, tslib_1.__assign({ showBadgeLabelBottom: !mouseOnAppBar, allowOpenInClick: true, badgeColor: "blue", iconSize: 3, iconName: "icon-users", stickTo: "right", numberstick: -72 }, props),
            React.createElement("div", { style: { padding: "1rem", width: "30rem", paddingTop: "2rem" } },
                this.renderNetworkAccounts(),
                React.createElement(ui_1.HLine, { topSpace: 0, bottomSpace: 1 }),
                React.createElement("div", { className: theme.actions, style: { alignItems: "center" } },
                    React.createElement(ui_1.Checkbox, { label: "Show Selected", defaultChecked: showAccountsNames, onChange: this.onChangeShowAccountsNames }),
                    isMultiSelectAllow ? (React.createElement(ui_1.Button, { type: "submit", blue: true, medium: true, uppercase: true, onClick: this.setAccounts }, "Set Accounts")) : null))));
    };
    return AccountsList;
}(React.Component));
exports.default = AccountsList;
